import React, { useContext } from 'react';
import { Context } from '../../store';
import { ReactComponent as Logo } from '../../assets/logo.svg';
import './style.scss';
import Sidebar from './mob';

const Navbar = ({ props }) => {
  // const [isMob, setIsMob] = useState(false);
  // useEffect(() => {
  //   window.addEventListener('resize', () => {
  //     console.log(window.innerWidth);
  //     if (window.innerWidth <= 600) {
  //       setIsMob(true);
  //     } else {
  //       setIsMob(false);
  //     }
  //   });
  // }, []);
  // useEffect(() => {
  //   window.addEventListener('resize', () => {
  //     console.log(window.innerWidth);
  //     if (window.innerWidth <= 600) {
  //       setIsMob(true);
  //     } else {
  //       setIsMob(false);
  //     }
  //   });
  // });
  const { state } = useContext(Context);
  return (
    <div
      className='navbar-container'
      style={{
        justifyContent: state.user ? 'space-between' : 'normal',
      }}>
      <div className='navbar-view'>
        <a href='/'>
          <Logo />
        </a>
        {props.match.url === '/main' || props.match.url === '/global' ? (
          <div
            className='navbar-profile'
            onClick={() => {
              props.history.push(`/profile/${state.token}`);
            }}>
            <img src={state.userImg} alt='userimage' />
            {state.username}
          </div>
        ) : null}
      </div>
      <div className='nav-mob'>
        <div
          style={{
            position: 'absolute',
            left: '4px',
            top: 0,
            transform: 'translateY(7px)',
          }}>
          <Sidebar props={props} />
        </div>
        {/* <a href='/'>{props.match.url !== '/' ? <Logo /> : null}</a> */}
      </div>
      {/* {!isMob ? (
        <>
        </>
      ) : (
      )} */}
    </div>
  );
};

export default Navbar;
